import { createContext, useContext } from "react";

export type Conversation = {
  id: string;
  name: string;
  subtitle: string;
  preview: string;
  timeLabel: string;
  unread: number;
};

export type QuoteLineItem = {
  label: string;
  amount: number;
};

export type ChatSender = "client" | "provider";

export type ChatMessage =
  | {
      id: string;
      sender: ChatSender;
      kind: "text";
      text: string;
      time: string;
    }
  | {
      id: string;
      sender: ChatSender;
      kind: "quote";
      quoteCode: string;
      subtitle: string;
      items: QuoteLineItem[];
    };

export type ChatState = {
  conversations: Conversation[];
  activeConversationId: string;
  setActiveConversationId: (id: string) => void;
  markConversationRead: (id: string) => void;
  messagesByConversation: Record<string, ChatMessage[]>;
  sendTextMessage: (conversationId: string, text: string, sender: ChatSender) => void;
};

export const ChatContext = createContext<ChatState | null>(null);

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used within ChatProvider");
  return ctx;
}

export type ChatMockData = {
  conversations: Conversation[];
  messagesByConversation: Record<string, ChatMessage[]>;
};
